import { ApiConnectionModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

export class ApiConnectionItemLoad {
  public static readonly type = '[ApiConnectionItem] Load';

  constructor(public payload: string) {}
}

export class ApiConnectionItemCreate {
  public static readonly type = '[ApiConnectionItem] Create';

  constructor(public payload: Partial<ApiConnectionModel>) {}
}

export class ApiConnectionItemUpdate {
  public static readonly type = '[ApiConnectionItem] Update';

  constructor(public payload: Partial<ApiConnectionModel>) {}
}

export class ApiConnectionItemDelete {
  public static readonly type = '[ApiConnectionItem] Delete';

  constructor(public payload: { dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>; apiConnectionId: number }) {}
}

export class ApiConnectionItemInitialState {
  public static readonly type = '[ApiConnectionItem] Set initial state';
}
